module.exports = __webpack_public_path__ + "img/SG-logo.e0b0705a.svg";